import React from "react";
import UAGLogo from "../../../images/logo.png";
import { Block, BlockBetween, BlockHead, BlockHeadContent, Icon } from "../../../components/Component";

const AuthError = ({ error_message }) => {
  return (
    <div
      style={{
        height: "40vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: "20px",
        background: "linear-gradient(135deg, #f8fafc, #edf2f7)"
      }}
    >
      <Block
        size="lg"
        style={{
          maxWidth: "500px",
          width: "100%",
          animation: "fadeIn 0.4s ease-out forwards"
        }}
      >
        <BlockBetween className="center">
          <BlockHead>
            <BlockHeadContent>
              {/* Logo */}
              <div
                className="brand-logo text-center"
                style={{
                  marginBottom: "2rem",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%"
                }}
              >
                <img
                  src={UAGLogo}
                  alt="logo-dark"
                  style={{ maxWidth: "100%", height: "220px", objectFit: "contain" }}
                />
              </div>

              {/* Error Card */}
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "2rem",
                  boxShadow: "0 6px 24px rgba(0, 0, 0, 0.08)",
                  textAlign: "center",
                  border: "1px solid rgba(0,0,0,0.04)",
                  animation: "fadeIn 0.6s ease-out forwards"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "1rem"
                  }}
                >
                  {/* Error Icon */}
                  <div
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      backgroundColor: "#fff5f5",
                      animation: "bounce 2s infinite"
                    }}
                  >
                    <Icon
                      name="alert-circle"
                      style={{
                        fontSize: "34px",
                        color: "#ff4d4f"
                      }}
                    />
                  </div>

                  {/* Title */}
                  <h2
                    style={{
                      color: "#2d3748",
                      fontSize: "1.25rem",
                      lineHeight: "1.5",
                      margin: 0,
                      fontWeight: "600"
                    }}
                  >
                    Oops! Something went wrong
                  </h2>

                  {/* Error Message */}
                  <div
                    style={{
                      maxWidth: "90%",
                      wordBreak: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical"
                    }}
                  >
                    <p
                      style={{
                        color: "#4a5568",
                        fontSize: "1.125rem",
                        fontWeight: "500",
                        margin: 0,
                        lineHeight: "1.4"
                      }}
                    >
                      {error_message}
                    </p>
                  </div>

                  {/* Divider */}
                  <div
                    style={{
                      height: "1px",
                      width: "100%",
                      background: "linear-gradient(90deg, transparent, rgba(0,0,0,0.08), transparent)",
                      margin: "1.2rem 0"
                    }}
                  ></div>

                  {/* Help Text */}
                  <p
                    style={{
                      color: "#718096",
                      fontSize: "0.875rem",
                      margin: 0
                    }}
                  >
                    Please try again or contact support if the problem persists.
                  </p>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
        </BlockBetween>
      </Block>

      {/* Animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-6px);
          }
        }
      `}</style>
    </div>
  );
};

export default AuthError;
